module.exports = __webpack_public_path__ + "static/media/profile.1eb8cd55.png";